"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedLanguages = void 0;
exports.supportedLanguages = ['en', 'fr', 'de', 'es', 'ar'];
